import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import PartnersHero from './components/PartnersHero';
import SponsorPackages from './components/SponsorPackages';
import PlacementShowcase from './components/PlacementShowcase';
import AdvertiseForm from './components/AdvertiseForm';

export default function PartnersPage() {
  return (
    <div className="bg-background-50 text-foreground-950 min-h-screen">
      <Header />
      <main>
        <PartnersHero />
        <SponsorPackages />
        <PlacementShowcase />
        <AdvertiseForm />
      </main>
      <Footer />
    </div>
  );
}